import moment from "moment";

export const formatDateToISO = (data: string | Date) => {
    return  moment(data).toISOString();
}

export default formatDateToISO;